import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "polling");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setAmount(r.data.amount);
        if (r.data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(r.data.payment_status)) return setState("failed");
      } catch (e) {}
      if (++attempts < 10) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [sessionId, cancelled]);

  const views = {
    polling: { icon: <Loader2 className="w-12 h-12 text-slate-500 animate-spin" />, title: "Vérification du paiement…", text: "Quelques secondes, nous confirmons votre règlement auprès de Stripe." },
    paid: { icon: <CheckCircle2 className="w-12 h-12 text-emerald-600" />, title: "Séance réglée !", text: `Votre réservation est verrouillée${amount ? ` (${amount.toFixed(2)} €)` : ""}. La salle a été prévenue.` },
    failed: { icon: <XCircle className="w-12 h-12 text-rose-600" />, title: "Paiement non abouti", text: "La session a expiré ou échoué. Vous pouvez réessayer depuis votre tableau de bord." },
    timeout: { icon: <Loader2 className="w-12 h-12 text-slate-400" />, title: "Confirmation en attente", text: "Le paiement est en cours de traitement. Vérifiez votre tableau de bord dans un instant." },
    cancelled: { icon: <XCircle className="w-12 h-12 text-slate-500" />, title: "Paiement annulé", text: "Aucun montant n'a été débité. Votre réservation reste confirmée, vous pourrez la régler plus tard." },
  };
  const v = views[state];

  return (
    <div>
      <Navbar />
      <div className="max-w-xl mx-auto px-6 py-20 text-center sc-fade-in" data-testid={`payment-${state}`}>
        <div className="grid place-items-center">{v.icon}</div>
        <h1 className="mt-6 text-3xl font-extrabold text-slate-900">{v.title}</h1>
        <p className="mt-3 text-slate-600">{v.text}</p>
        <Link data-testid="payment-back-dashboard" to="/tableau-de-bord" className="mt-8 inline-flex sc-btn sc-btn-primary">Retour au tableau de bord</Link>
      </div>
      <Footer />
    </div>
  );
}
